// src/logic/authService.ts
import {
  setAccessToken,
  clear,
  setAccessTokenExpiration,
} from "../features/authSlice";
import store from "../store";

let inMemoryToken: string | null = null;

export const authService = {
  getToken(): string | null {
    try {
      const state = store.getState() as any;
      if (state?.auth?.accessToken) return state.auth.accessToken;
    } catch {}
    return inMemoryToken;
  },

  getAccessTokenExpiration(): Date | null {
    try {
      const state = store.getState() as any;
      if (state?.auth?.accessTokenExpiration)
        return state.auth.accessTokenExpiration;
    } catch {}
    return null;
  },

  setToken(token: string | null) {
    inMemoryToken = token ?? null;
    try {
      store.dispatch(setAccessToken(token));
    } catch {}
  },

  setAccessTokenExpiration(expiration: Date | null) {
    try {
      store.dispatch(setAccessTokenExpiration(expiration));
    } catch {}
  },

  clearToken() {
    inMemoryToken = null;
    try {
      store.dispatch(clear());
    } catch {}
  },
};
